import { P03 } from "./CustomerGroupSales/P03";

export const DistributorCustomerGroupSummary = {
  "sections": [
    P03
  ]
}